import Notifications from 'components/notifications';
import VideoHelp from 'components/video-help';
import { createContext, ReactNode, useCallback, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface ModalContextData {
  showModal: (modalId: string, data?: any) => void;
  closeModal: () => void;
  openModal?: string;
  modalData: any;
}

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalContext = createContext({} as ModalContextData);

function ModalProvider({ children }: ModalProviderProps) {
  const location = useLocation();

  const [openModal, setOpenModal] = useState<string | undefined>();
  const [modalData, setModalData] = useState<any>();

  const showModal = useCallback((modalId: string, data?: any) => {
    setOpenModal(modalId);
    setModalData(data);
  }, []);

  const closeModal = useCallback(() => {
    setOpenModal(undefined);
    setModalData(undefined);
  }, []);

  // function showModal(modalId: string, data?: any) {
  //   setOpenModal(modalId);
  //   setModalData(data);
  // }

  // function closeModal() {
  //   setOpenModal(undefined);
  //   setModalData(undefined);
  // }

  useEffect(() => {
    closeModal();
  }, [closeModal, location]);

  return (
    <ModalContext.Provider
      value={{
        showModal,
        closeModal,
        openModal,
        modalData,
      }}
    >
      {children}
      <Notifications />
      <VideoHelp />
    </ModalContext.Provider>
  );
}

function useModal() {
  const context = useContext(ModalContext);

  if (context === undefined) {
    throw new Error('useWebsocket must be used within a WebsocketProvider');
  }
  return context;
}

export { ModalProvider, useModal };
